import { Component, ViewChild } from '@angular/core';
import { LiveApiService } from '../../../services/live-api.service';
import { LiveCreateStream, LiveApiError } from '../../../interfaces/live';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { OverlayService } from '../../../services/overlay.service';
import { NgForm, ValidationErrors } from '@angular/forms';

@Component({
	selector: 'upload-transcode-bb-livestream',
	templateUrl: './upload-transcode-bb-livestream.component.html',
	styleUrls: ['./upload-transcode-bb-livestream.component.scss']
})
export class UploadTranscodeBbLivestreamComponent {
	@ViewChild('formRef', { static: true }) form: NgForm;

	title: string;
	streamName: string;
	streamType = 'video';
	ingestType = 'rtmp';
	ingestVariant = 'simple';
	putRight = false;

	private previousVideoIngestType: string;
	private previousAudioIngestType: string;
	private previousStreamType: string = this.streamType;

	constructor(
		private liveApiService: LiveApiService,
		private router: Router,
		private authenticationService: AuthenticationService,
		private overlayService: OverlayService
	) {
		this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight);
	}

	createLiveStream(): void {
		if (this.putRight) {
			const createStreamObject: any = {};

			if (this.streamName) {
				createStreamObject['stream-name'] = this.streamName;
			}

			if (this.ingestType && this.ingestType === 'rtmp' && this.ingestVariant) {
				createStreamObject['ingest-variant'] = this.ingestVariant;
			}

			createStreamObject.type = this.streamType;
			createStreamObject['ingest-type'] = this.ingestType;
			createStreamObject.mediacliptitle = this.title;

			this.overlayService.setLoading(true);

			this.liveApiService.postUrl('/stream', createStreamObject).subscribe((res: LiveCreateStream) => {
				const mediaclipId = res.data.mediaclipid;
				this.router.navigate(['/library/mediaclip/', mediaclipId, 'bb-streams']);
			}, (error: any) => {
				this.overlayService.setLoading(false);

				const errResponse: LiveApiError = error.error;

				if (errResponse.code && errResponse.code === 'invalid_request') {
					const errors: ValidationErrors = {};

					if (errResponse.message.toString().indexOf('illegal') > -1) {
						errors['invalid-format'] = true;
					}

					if (errResponse.message.toString().indexOf('exists') > -1) {
						errors['not-unique'] = true;
					}

					this.form.form.controls['stream-name'].setErrors(errors);
				}
			});
		}
	}

	streamTypeChanged(): void {
		if (this.previousStreamType !== this.streamType) {
			if (this.streamType === 'audio') {
				this.previousVideoIngestType = this.ingestType;
			} else if (this.streamType === 'video') {
				this.previousAudioIngestType = this.ingestType;
			}

			this.ingestType =
				(this.streamType === 'audio') ? (this.previousAudioIngestType || 'icecast') : (this.previousVideoIngestType || 'rtmp');
			this.previousStreamType = this.streamType;
		}
	}

	streamNameChanged(): void {
		if (!/^[a-zA-Z0-9-_]{1,24}$/.test(this.streamName)) {
			const errors: ValidationErrors = { 'invalid-format': true };
			this.form.form.controls['stream-name'].setErrors(errors);
		}
	}
}
